module.exports = __webpack_public_path__ + "img/updatePass2.7c9e595d.png";